/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Navigate } from 'react-router-dom'

import { AppContext } from '../AppContext'

class SecureLoginUrl extends React.Component 
{
  componentMounted = false;

  componentDidMount()
  {
    if (this.componentMounted) return;                // React Strict mode is a PITA. They call componentDidMount twice...
    this.componentMounted = true;
    // because we only expect a single argument,
    // instead of parsing multiple query arguments, 
    // we can actually treat this as a security
    // enhancement and ignore requests that aren't
    // what we expect
    if (window.location.search.substring(0, 1) !== '?'
     || /[^0-9a-zA-Z]/.test(window.location.search.substring(1)))
    {
      // redirect back to login page
      // to external URI:
      // window.location.href = this.redirectURI;
      // can use history.push() if you want the current page to stay in the browser history
      this.setState({validationStatus: 'failed'});
      return;
    }

    // by taking the entire query string without checking, if the user
    // adds anything funny, they will just invalidate their request
    // (as long as the DB passes this entire string to its decrypt function)
    this.validateConfirmationToken();
  }
  
  constructor(props)
  {
    super();

    this.state =
    {
      validationStatus: undefined
    }
  }

  render()
  {
    if ('failed' === this.state.validationStatus) return (<Navigate to={{pathname: '/login', replace: true}} />);
    return null;
  }

  async validateConfirmationToken()
  {
    let bodyData = {confirmationToken: window.location.search.substring(1)};
    let result = await this.context.dbTwig.callRestAPI('icam', 'validateLoginUrl', bodyData);
    if ('apiError' === result.status && this.context.dbTwig.InvalidConfirmationData === result.errorCode) 
    {
      this.setState({validationStatus: 'failed'});
      return;
    }
      
    if ('success' !== result.status) return (<Navigate to={{pathname: '/login', replace: true}} />);

    switch (result.jsonData.sessionStatus)
    {
      case 'active':
      case 'change password':
        this.context.postNotification('success', 'Login authorization successful');
        this.context.authorize(result.jsonData);
        break;

      case 'session limit':
        this.context.postNotification('info', 'You are logged in but your session is blocked');
        this.context.authorize(result.jsonData);
        break;

      default:
        this.setState({validationStatus: 'failed'});
        break;
    }
  }
}

SecureLoginUrl.contextType = AppContext;

export default SecureLoginUrl
